import { createContext } from 'react';
import { AuthContext, UserData } from './AuthContext.types';

export const authCtxValue: AuthContext = {
  user: null,
  setUser: (state: UserData | null) => {}, //eslint-disable-line
};

export const appAuthContext = createContext(authCtxValue);
